import zod from "zod";

export const postStoryInputSchema = zod.object({
    handleName: zod
        .string()
        .trim()
        .min(1, { message: "ハンドルネームを入力してください。" }),
    title: zod.string().trim(),
    body: zod.string().trim().min(1, { message: "内容を入力してください。" }),
});

export type PostStoryInput = zod.infer<typeof postStoryInputSchema>;
